export enum UserCredentialsType {
  AGENT = 'agent',
  ADMIN = 'admin',
  CHANNEL = 'channel',
}
